import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const getFinixMerchant =
  (axios: IAxiosInstance) => async (params: { companyID: string }) => {
    const response = await axios.noRetry.get(
      "/api/business-cards/finix-merchant",
      {
        params,
      }
    );
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Error getting Finix merchant");
  };
